import { render, staticRenderFns } from "./VoidModal.vue?vue&type=template&id=f2037a0c&scoped=true"
import script from "./VoidModal.vue?vue&type=script&lang=js"
export * from "./VoidModal.vue?vue&type=script&lang=js"
import style0 from "./VoidModal.vue?vue&type=style&index=0&id=f2037a0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2037a0c",
  null
  
)

export default component.exports